import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "play",
  "use": "play-usage",
  "viewBox": "0 0 90 90",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 90 90\" id=\"play\">\n  <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M45 85c22.091 0 40-17.909 40-40S67.091 5 45 5 5 22.909 5 45s17.909 40 40 40Zm10.386-39.7a.347.347 0 0 0 0-.6l-15.322-8.847a.347.347 0 0 0-.52.3v17.693c0 .268.289.435.52.301l15.322-8.846Z\" clip-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol